<template>
  <div class="position-absolute w-100 pointer-events-none overflow-hidden z-20 page-footer-wrap" :style="wrapStyles">
    <div class="position-relative inner-footer" :style="wrapStyles">

      <svg xmlns="http://www.w3.org/2000/svg" :viewBox="'0 0 ' + winW + ' ' + wrapH">
        <defs>
          <linearGradient id="page0-a" x1="50%" x2="50%" y1="96.708%" y2="0%">
            <stop offset="0%" :stop-color="mainColor"/>
            <stop offset="100%" :stop-color="accent"/>
          </linearGradient>
          <linearGradient id="page0-b" x1="109.79%" x2="19.695%" y1="110.966%" y2="11.299%">
            <stop offset="0%" :stop-color="darkAccent"/>
            <stop offset="100%" :stop-color="accent"/>
          </linearGradient>
          <linearGradient id="page0-c" x1="50%" x2="50%" y1="26.741%" y2="100%">
            <stop offset="0%" :stop-color="accent"/>
            <stop offset="100%" :stop-color="lightAccent" stop-opacity="0"/>
          </linearGradient>
        </defs>
        <polygon
          fill="url(#page0-a)"
          :points="winW + ' ' + wrapH + ' 0 ' + wrapH + ' 0 0 ' + winW + ' ' + backPt"
          ref="backGrad"
        />
        <polygon
          fill="url(#page0-b)"
          :points="'0 ' + wrapH + ' 0 ' + frontPtLow + ' ' + winW + ' ' + frontPtHigh + ' ' + winW + ' ' + wrapH"
          ref="pageGrad"
        />
        <circle :cx="winW - 16.5" cy="253.5" r="62.5" fill="url(#page0-c)" fill-opacity=".7" ref="circ"/>
      </svg>

      <div
        class="position-absolute w-100 d-flex flex-column justify-content-center align-items-center user-select-none footer-text"
        :class="[ allowPointer ? 'pointer-events-auto' : '' ]"
        :style="{ height: h + 'px' }"
        @click="handleClick"
        @touchstart="touchstart"
        @touchmove.prevent="touchmove"
        @touchend="touchend"
        ref="footText"
      >
        <span ref="numeral" class="numeral" v-html="numeral + '.'"></span>
        <span ref="keyword" class="keyword" v-html="keyword"></span>
        <span ref="subhead" class="subhead" v-html="subhead"></span>
      </div>
    </div>
  </div>

</template>

<script>
  import { TimelineMax, Power1 } from 'gsap'
  import { lighten, darken } from '@/lib/funcs'
  import FooterMixin from '@/components/report/mixins/FooterMixin'

  export default {
    name: 'Foot0',
    mixins: [ FooterMixin ],
    data () { return { tl: new TimelineMax() } },
    computed: {
      lightAccent () {
        return lighten( this.accent, 178 / 255 )
      },
      darkAccent () {
        return darken( this.accent, (255 - 85) / 255 )
      }
    },
    methods: {
      setTweens () {
        this.tl.set( this.$refs.keyword, { yPercent: 50, rotationX: 30, rotationY: 30 } )
          .set( this.$refs.subhead, { yPercent: 100 } )
          .set( [ this.$refs.numeral, this.$refs.keyword, this.$refs.subhead, this.$refs.circ ], { opacity: 0 } )
          .set( [ this.$refs.pageGrad, this.$refs.backGrad, this.$refs.circ, this.$refs.footText ], { y: this.wrapH } )
          .set( this.$refs.circ, { xPercent: 100 } )
      },

      tweenIn () {
        this.tl.staggerTo( [ this.$refs.pageGrad, this.$refs.backGrad, this.$refs.footText ], this.time, {
          y: this.wrapH - this.h,
          ease: Power1.easeInOut
        }, this.stagger, 'in' )
          .to( this.$refs.numeral, this.time / 2, { opacity: 1 }, 'in+=' + (this.stagger * 3 + this.time * 0.5) )
          .to( this.$refs.keyword, this.time / 2, {
            opacity: 1,
            rotationX: 0,
            rotationY: 0,
            yPercent: 0
          }, 'in+=' + (this.stagger * 4 + this.time * 0.5) )
          .to( this.$refs.subhead, this.time / 2, {
            opacity: 1,
            yPercent: 0
          }, 'in+=' + (this.stagger * 5 + this.time * 0.5) )
          .to( this.$refs.circ, this.time, { y: '-=' + this.h, xPercent: 0, opacity: 1 }, 'in+=' + (this.stagger * 3) )
      },

      tweenOut () {
        this.tl.to( this, this.time, { backPt: 0, frontPtLow: 0, frontPtHigh: 0, ease: Power1.easeInOut }, 'out' )
          .to( [ this.$refs.backGrad, this.$refs.pageGrad ], this.time, { y: 0, ease: Power1.easeInOut }, 'out' )
          .to( [ this.$refs.footText, this.$refs.circ ], this.time / 2, { opacity: 0 }, 'out' )
          .to( this.$refs.keyword, this.time, { yPercent: 50, rotationX: 30, rotationY: 30 }, 'out' )
          .to( this.$refs.subhead, this.time, { yPercent: 100 }, 'out+=' + this.stagger )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/report/footers/Foot0.vue